import { render } from "./MasterDataColumns.vue?vue&type=template&id=7e5361a7&scoped=true&ts=true"
import script from "./MasterDataColumns.vue?vue&type=script&lang=ts"
export * from "./MasterDataColumns.vue?vue&type=script&lang=ts"

import "./MasterDataColumns.vue?vue&type=style&index=0&id=7e5361a7&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5361a7"]])

export default __exports__